/** Queries for 'Valuta' */

import { tag } from 'api/rtkTags'
// eslint-disable-next-line
import { initialCurrency } from 'constants/initialValues'
import { label } from 'constants/labels'

export const queryGetPagedCurrency = (pageNumber, pageSize, options = {}) => {
  return {
    query: {
      name: 'data',
      mode: 'page',
      type: 'valuta',
      data: {
        pageNumber,
        pageSize,
        options: {
          ...options,
          order: [['naziv', 'ASC']]
        }
      }
    },
    providesTags: {
      type: tag.currency
    }
  }
}

export const queryGetAllCurrency = () => {
  return {
    query: {
      name: 'data',
      mode: 'all',
      type: 'valuta',
      data: {
        options: {
          order: [['naziv', 'ASC']]
        }
      }
    },
    providesTags: {
      type: tag.currency
    }
  }
}
/**
 * @param {initialCurrency} data
 */
export const queryAddCurrency = data => {
  return {
    query: {
      name: 'data',
      mode: 'new',
      type: 'valuta',
      data: { values: data }
    },
    invalidatesTags: [tag.currency],
    successMsg: label.successMsgCreate + ' ' + label.msgCurrency
  }
}

/**
* @param {initialCurrency} data
@param {string} id
*/
export const queryUpdateCurrency = (data, id) => {
  return {
    query: {
      name: 'data',
      mode: 'update',
      type: 'valuta',
      data: {
        values: data,
        options: {
          where: {
            id
          }
        }
      }
    },
    invalidatesTags: [tag.currency],
    successMsg: label.successMsgEdit + ' ' + label.msgCurrency
  }
}
/**
@param {string} id
*/
export const queryDeleteCurrency = id => {
  return {
    query: {
      name: 'data',
      mode: 'delete',
      type: 'valuta',
      data: {
        options: {
          where: { id }
        }
      }
    },
    invalidatesTags: [tag.currency],
    successMsg: label.successMsgDelete + ' ' + label.msgCurrency
  }
}

export const queryGetPagedCurrencyList = (pageNumber, pageSize, options = {}) => {
  return {
    query: {
      name: 'data',
      mode: 'page',
      type: 'kursnaLista',
      data: {
        pageNumber,
        pageSize,
        options
      }
    },
    providesTags: {
      type: tag.currencyList
    }
  }
}
